import { SUB_QUERY_URI_DELIMITER } from '@components/Studio/QueryCreationTwo/ActionButtons/Calcs/components/FormulaEditor/utils/constants/editorOptions';
import { regexToMatchSubQueryUrisUpToFirstAtDelim } from '@components/Studio/QueryCreationTwo/ActionButtons/Calcs/utils/constants/regexDefinitions';
import { IQuestionById } from '@redux/Studio/QueryCreation/constants/queryCreation.interface';
import { getSubQuestionName } from 'utils/Studio/QueryCreation/QuestionOutputLabels';

/**
 * Replaces, @'s, #'s & $'s in the formula string to concept[property]
 * Used in Calc cards, for the formula preview
 * @param input string
 * @returns string
 */
export const convertFormulaString = (input: string, query: IQuestionById): string => {
  const subQueryUriMatch = input.match(regexToMatchSubQueryUrisUpToFirstAtDelim) || [];
  const uniqueMatches = new Set(subQueryUriMatch);
  let argWithSubQueryName = input;

  uniqueMatches.forEach((match) => {
    const subQueryUri = match.replace(SUB_QUERY_URI_DELIMITER, '/') || '';
    let subQueryName = getSubQuestionName(query, subQueryUri);

    // remove sub-query uri, & replace it with the "subQueryName ¦ " if it exists
    argWithSubQueryName = argWithSubQueryName.replaceAll(
      match + SUB_QUERY_URI_DELIMITER,
      subQueryName + ' ¦ '
    );
  });

  return argWithSubQueryName
    .replace(/(\w+)@([^@]+)@/g, (match, p1, p2) => `${p1}[${p2}]`)
    .replaceAll('#', '')
    .replace(/\$(\w+)\(/g, (match, p1) => `${p1}(`);
};
